import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">欢迎商务合作、版权咨询和内容投稿</p>
        </div>
        <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/50 text-center">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-lg mx-auto">{contactInfo.description}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            <div className="flex items-center gap-2 text-foreground-700">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </span>
              <span className="text-sm">{contactInfo.email}</span>
            </div>
            <div className="flex items-center gap-2 text-foreground-700">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-wechat-line text-accent-500 text-lg"></i>
              </span>
              <span className="text-sm">{contactInfo.wechat}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}